export default {"src":"/_next/static/image/public/images/ic_reject_profile.d89242be1c6932ace0221e2464ca49fc.svg","height":140,"width":126};